/* BG COM — exploded-view scroll-scrub engine (v2), rendered by the PDP stack as the "Vue éclatée" module.
   Config: JSON block .bgcom-scrub-config inside #nv3-root (from the product metafield bgcom.vue_eclatee):
     frames, fw, fh, cols, per, hold, sheets[], compat, label, carousel, specs[{t,d}], parts[{x,y,s,t,h,i,l}]
   Attributes on #nv3-root: data-video, data-poster, data-still-start, data-still-end (full-res stills).
   v2 vs v1: contained in the page width (12px card, fits the screen under the sticky header) instead of
   full-bleed; full-resolution stills drawn at rest (first frame, exploded view) for crispness; shorter
   scroll track with more pinned time once the parts are clickable; UI in the site's type and tokens;
   mobile list in light cards. Kept: eased scrubbing, off-thread decoding, lazy sheet loading (never on
   mobile), nearest-frame fallback, shared BG COM hotspot card. */
(function () {
  var root = document.getElementById('nv3-root');
  if (!root || root.dataset.nv3Init) return;
  root.dataset.nv3Init = '1';

  var cfgEl = root.querySelector('.bgcom-scrub-config');
  var C = {};
  try { C = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { C = {}; }
  if (!C.sheets || !C.sheets.length) return;
  var FW = C.fw || 1600, FH = C.fh || 896, COLS = C.cols || 3, PER = C.per || 12, FRAME_COUNT = C.frames || 81;
  var HOLD = C.hold || 0.8, HS_AT = C.hotspotsAt || (HOLD + 0.02), EASE = C.ease || 0.16, TRACK = C.track || 1.1;
  var CDN = C.cdn || 'https://cdn.shopify.com/s/files/1/0898/7616/8969/files/';
  var SHEETS = C.sheets.map(function (f) { return /^https?:/.test(f) ? f : CDN + f; });
  var LABEL = C.label || 'Pièce détachée', COMPAT = C.compat || '';
  var PARTS = C.parts || [], SPECS = C.specs || [];
  var CAROUSEL = C.carousel || 'Pièces disponibles';
  var WIN = [[0.12, 0.36], [0.36, 0.6], [0.6, 0.84]];   // captions start once the scroll prompt has gone
  var PLUS = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  function escH(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function img(u) { return /^https?:|^\/\//.test(u) ? u : CDN + u; }

  /* ---------- styles: contained card, site tokens ---------- */
  if (!document.getElementById('nv3-css')) {
    var css = [
      '#nv3-root{--x3d-bg:#000;--x3d-red:#E10600;--x3d-ink:#f4f4f5;--x3d-dim:#a1a1aa;position:relative;width:100%;font-family:inherit}',
      '#nv3-stage{position:relative}',
      '.nv3-pin{position:absolute;top:0;left:0;width:100%;background:#fff}',
      '.nv3-pin .bgs-x3d__head{margin:0 0 16px}',
      '.nv3-card{position:relative;overflow:hidden;background:var(--x3d-bg);border-radius:12px}',
      '.nv3-canvas{position:absolute;inset:0;width:100%;height:100%;display:block}',
      '.nv3-video{position:absolute;inset:0;width:100%;height:100%;display:none;object-fit:contain}',
      '.nv3-shade{position:absolute;inset:0;pointer-events:none;background:linear-gradient(0deg,rgba(0,0,0,.72) 0%,rgba(0,0,0,0) 34%)}',
      /* the scroll prompt is also a button: it plays the whole animation for people who do not scroll */
      '.nv3-cta{position:absolute;left:50%;bottom:28px;z-index:5;transform:translateX(-50%);display:inline-flex;align-items:center;gap:12px;min-height:56px;padding:0 24px 0 18px;border:0;border-radius:999px;background:#fff;color:#171717;font:inherit;font-size:16px;font-weight:800;line-height:1.2;white-space:nowrap;cursor:pointer;box-shadow:0 12px 32px rgba(0,0,0,.45);transition:opacity .35s ease,transform .35s ease,background-color .15s ease}',
      '.nv3-cta:hover{background:#f4f4f5}.nv3-cta:focus-visible{outline:3px solid rgba(225,6,0,.7);outline-offset:3px}',
      '.nv3-cta-m{position:relative;flex:0 0 auto;width:22px;height:34px;border:2.5px solid #171717;border-radius:12px}',
      ".nv3-cta-m::after{content:'';position:absolute;left:50%;top:6px;width:4px;height:8px;margin-left:-2px;border-radius:2px;background:var(--x3d-red);animation:nv3wheel 1.6s ease-in-out infinite}",
      '.nv3-cta-a{color:var(--x3d-red);font-size:20px;font-weight:900;display:inline-block;animation:nv3bob 1.4s ease-in-out infinite}',
      '@keyframes nv3wheel{0%{transform:translateY(0);opacity:1}70%{transform:translateY(11px);opacity:0}100%{transform:translateY(11px);opacity:0}}',
      '#nv3-root.nv3-go .nv3-cta{opacity:0;pointer-events:none;transform:translate(-50%,14px)}',
      '@keyframes nv3bob{0%,100%{transform:translateY(0)}50%{transform:translateY(4px)}}',
      '.nv3-specs{position:absolute;left:24px;right:24px;bottom:26px;height:64px;pointer-events:none;transition:opacity .4s ease}',
      '.nv3-spec{position:absolute;left:0;bottom:0;display:flex;align-items:flex-start;gap:14px;opacity:0;transform:translateY(10px);transition:opacity .45s ease,transform .45s ease}',
      '.nv3-spec.is-on{opacity:1;transform:none}',
      '.nv3-spec-k{font-weight:800;font-size:22px;line-height:1;color:var(--x3d-red);font-variant-numeric:tabular-nums;min-width:1.4em}',
      '.nv3-spec-t{font-size:13.5px;line-height:1.45;max-width:44ch;font-weight:500;color:var(--x3d-dim)}',
      '.nv3-spec-t b{display:block;font-size:15px;font-weight:800;color:var(--x3d-ink);margin-bottom:2px}',
      '.nv3-progress{position:absolute;left:0;right:0;bottom:0;height:3px;background:rgba(255,255,255,.12)}',
      '.nv3-progress-fill{position:absolute;inset:0;background:var(--x3d-red);transform-origin:0 50%;transform:scaleX(0)}',
      '#nv3-root.nv3-hs .nv3-specs{opacity:0}',
      '.nv3-hotspots{position:absolute;left:0;top:0;opacity:0;transition:opacity .45s ease;pointer-events:none;z-index:4}',
      '.nv3-hotspots.is-live{opacity:1;pointer-events:auto}',
      '.nv3-carousel{display:none}',
      '.nv3-cover{display:none}',
      ".nv3-cover.is-tap::after{content:'';position:absolute;left:50%;top:50%;width:56px;height:56px;margin:-28px 0 0 -28px;border-radius:50%;background:#E10600 url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath d='M8 5.5v13l11-6.5z' fill='white'/%3E%3C/svg%3E\") 55% 50%/22px no-repeat;box-shadow:0 8px 24px rgba(0,0,0,.4)}",
      '@media (max-width:767px),(prefers-reduced-motion:reduce){#nv3-stage{height:auto!important}.nv3-pin{position:relative!important;top:auto!important;left:auto!important;width:100%!important;height:auto!important;background:none}.nv3-card{height:auto!important;aspect-ratio:16/9}.nv3-canvas{display:none}.nv3-video{display:block}.nv3-cover{display:block;position:absolute;inset:0;width:100%;height:100%;border:0;padding:0;margin:0;background:#000 center/contain no-repeat;cursor:pointer;transition:opacity .35s ease}.nv3-cover.is-off{opacity:0;pointer-events:none}.nv3-cta,.nv3-specs,.nv3-progress,.nv3-hotspots,.nv3-shade{display:none}',
      '.nv3-carousel{display:block;padding:16px 0 0}',
      '.nv3-carousel-h{font-size:12px;font-weight:800;letter-spacing:.12em;text-transform:uppercase;color:#5c5c5c;margin:0 0 10px}.nv3-carousel-h b{color:var(--x3d-red)}',
      '.nv3-track{display:flex;gap:10px;overflow-x:auto;-webkit-overflow-scrolling:touch;scroll-snap-type:x mandatory;padding:0 0 6px;scrollbar-width:none}.nv3-track::-webkit-scrollbar{display:none}',
      '.nv3-pcard{scroll-snap-align:start;flex:0 0 152px;width:152px;display:flex;flex-direction:column;background:#fff;border:1px solid #e6e6e6;border-radius:12px;overflow:hidden;color:#171717;text-align:left;padding:0;font:inherit;cursor:pointer}',
      '.nv3-pcard-img{display:block;margin:8px 8px 0;height:104px;background:#f5f5f5 center/contain no-repeat;border-radius:8px}',
      '.nv3-pcard-b{padding:9px 10px 10px;display:flex;flex-direction:column;gap:3px;flex:1}',
      '.nv3-pcard-ref{font-weight:800;font-size:10px;letter-spacing:.1em;text-transform:uppercase;color:var(--x3d-red)}',
      '.nv3-pcard-t{font-weight:700;font-size:12.5px;line-height:1.25;color:#171717;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:31px}',
      '.nv3-pcard-f{display:flex;align-items:center;justify-content:space-between;margin-top:auto;padding-top:6px;font-size:11.5px;font-weight:700;color:#5c5c5c}',
      '.nv3-pcard-go{flex:0 0 auto;width:26px;height:26px;border-radius:50%;background:var(--x3d-red);color:#fff;display:grid;place-items:center}.nv3-pcard-go svg{width:12px;height:12px}}',
      '@media (prefers-reduced-motion:reduce){.nv3-spec,.nv3-cta{transition:none}.nv3-cta-m::after,.nv3-cta-a{animation:none}}'
    ].join('');
    var st = document.createElement('style'); st.id = 'nv3-css';
    st.appendChild(document.createTextNode(css)); document.head.appendChild(st);
  }

  var specsHtml = SPECS.map(function (sp, i) {
    var w = WIN[i] || [0, 0];
    return "<div class='nv3-spec' data-from='" + (sp.from != null ? sp.from : w[0]) + "' data-to='" + (sp.to != null ? sp.to : w[1]) + "'>" +
      "<span class='nv3-spec-k'>" + ('0' + (i + 1)).slice(-2) + "</span><span class='nv3-spec-t'><b>" + escH(sp.t) + '</b>' + escH(sp.d) + '</span></div>';
  }).join('');
  root.innerHTML =
    "<div id='nv3-stage'><div class='nv3-pin'><div class='nv3-card'><canvas class='nv3-canvas'></canvas>" +
    "<video class='nv3-video' muted playsinline preload='none' disablepictureinpicture></video>" +
    "<div class='nv3-shade'></div><div class='nv3-hotspots'></div>" +
    "<button type='button' class='nv3-cta' aria-label='Voir les pièces : lancer la vue éclatée'><span class='nv3-cta-m' aria-hidden='true'></span><span>Faites défiler pour voir les pièces</span><span class='nv3-cta-a' aria-hidden='true'>↓</span></button>" +
    "<div class='nv3-specs'>" + specsHtml + "</div><div class='nv3-progress'><span class='nv3-progress-fill'></span></div>" +
    '</div></div></div>';

  var stage = root.querySelector('#nv3-stage'), pin = root.querySelector('.nv3-pin'), card = root.querySelector('.nv3-card');
  var cta = root.querySelector('.nv3-cta');
  /* the module heading travels with the card, so the page never shows a floating dark box without its title */
  var head = root.parentNode && root.parentNode.querySelector('.bgs-x3d__head');
  if (head) pin.insertBefore(head, card);
  var canvas = root.querySelector('.nv3-canvas'), ctx = canvas.getContext('2d', { alpha: false });
  var video = root.querySelector('.nv3-video'), fill = root.querySelector('.nv3-progress-fill');
  var specs = [].slice.call(root.querySelectorAll('.nv3-spec')), hot = root.querySelector('.nv3-hotspots');
  var stillStartSrc = root.getAttribute('data-still-start'), stillEndSrc = root.getAttribute('data-still-end');
  var poster = stillStartSrc || root.getAttribute('data-poster');
  if (poster) video.setAttribute('poster', poster);

  var mq = window.matchMedia('(max-width:767px)'), reduce = window.matchMedia('(prefers-reduced-motion:reduce)');
  function mobile() { return mq.matches || reduce.matches; }

  /* ---------- sources: sprite sheets (motion) + full-res stills (rest) ---------- */
  var sheets = new Array(SHEETS.length), loadingStarted = false, stills = {};
  function decoded(im, done) {
    if (window.createImageBitmap) createImageBitmap(im).then(done, function () { done(im); });
    else if (im.decode) im.decode().then(function () { done(im); }, function () { done(im); });
    else done(im);
  }
  function loadImg(src, cb) { var im = new Image(); im.decoding = 'async'; im.onload = function () { decoded(im, cb); }; im.onerror = function () { cb(null); }; im.src = src; }
  function loadSheet(idx) {
    return new Promise(function (resolve) {
      loadImg(SHEETS[idx], function (bmp) { if (bmp) sheets[idx] = bmp; resolve(); redraw(); });
    });
  }
  function startLoading() {
    if (loadingStarted || mobile()) return;
    loadingStarted = true;
    if (stillStartSrc) loadImg(stillStartSrc, function (b) { if (b) { stills.start = b; redraw(); } });
    if (stillEndSrc) loadImg(stillEndSrc, function (b) { if (b) { stills.end = b; redraw(); } });
    var next = 0;
    function pump() { if (next >= SHEETS.length) return; loadSheet(next++).then(pump); }
    pump(); pump();
  }
  function sheetFor(i) { return sheets[Math.floor(i / PER)]; }
  function nearestReady(i) {
    if (sheetFor(i)) return i;
    for (var d = 1; d < FRAME_COUNT; d++) {
      if (i - d >= 0 && sheetFor(i - d)) return i - d;
      if (i + d < FRAME_COUNT && sheetFor(i + d)) return i + d;
    }
    return -1;
  }
  var drawnKey = '';
  function fitRect(sw, sh) {
    var cw = canvas.width, ch = canvas.height, s = Math.min(cw / sw, ch / sh);
    return { w: sw * s, h: sh * s, x: (cw - sw * s) / 2, y: (ch - sh * s) / 2 };
  }
  function drawFrame(i) {
    if (!ctx || !canvas.width) return;
    i = Math.max(0, Math.min(FRAME_COUNT - 1, i));
    var still = (i === 0 && stills.start) ? stills.start : ((i === FRAME_COUNT - 1 && stills.end) ? stills.end : null);
    var key, src, sx = 0, sy = 0, sw, sh;
    if (still) { key = 's' + i; src = still; sw = still.width; sh = still.height; }
    else {
      var j = nearestReady(i);
      if (j < 0) { if (drawnKey !== 'bg') { ctx.fillStyle = '#000'; ctx.fillRect(0, 0, canvas.width, canvas.height); drawnKey = 'bg'; } return; }
      key = 'f' + j; src = sheetFor(j);
      var k = j % PER; sx = (k % COLS) * FW; sy = Math.floor(k / COLS) * FH; sw = FW; sh = FH;
    }
    if (key === drawnKey) return;
    var r = fitRect(FW, FH);                 // same box for frames and stills, so hotspots never move
    ctx.fillStyle = '#000'; ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.imageSmoothingEnabled = true; ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(src, sx, sy, sw, sh, r.x, r.y, r.w, r.h);
    drawnKey = key;
  }
  function redraw() { drawnKey = ''; drawFrame(Math.round(cur)); }

  /* ---------- eased scrub ---------- */
  var target = 0, cur = 0, raf = 0;
  function tick() {
    raf = 0;
    var d = target - cur;
    cur = Math.abs(d) < 0.05 ? target : cur + d * EASE;
    drawFrame(Math.round(cur));
    if (cur !== target) raf = requestAnimationFrame(tick);
  }
  function setTarget(f) {
    target = f;
    if (reduce.matches || document.hidden) { cur = f; drawFrame(Math.round(f)); return; }
    if (!raf) raf = requestAnimationFrame(tick);
  }

  /* ---------- geometry: a card that fits under the sticky header ---------- */
  var topInset = 0, H = 0, W = 0, T = 0;
  function computeInset() {
    // where the sticky header ends once it is stuck (at page top it still sits under the announcement bar)
    var best = 0;
    document.querySelectorAll('header, sticky-header, [class*="header"], [id*="header"]').forEach(function (el) {
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') return;
      var r = el.getBoundingClientRect();
      if (r.height <= 4 || r.height >= 240 || r.width < window.innerWidth * 0.5) return;
      var top = cs.position === 'sticky' ? (parseFloat(cs.top) || 0) : r.top;
      if (top <= 2 && top + r.height > best) best = top + r.height;
    });
    topInset = best;
  }
  function layout() {
    if (mobile()) {
      stage.style.height = ''; pin.style.height = ''; card.style.height = '';
      pin.style.position = ''; pin.style.top = ''; pin.style.left = ''; pin.style.width = ''; pin.style.bottom = '';
      return;
    }
    computeInset();
    var vh = window.innerHeight;
    W = stage.clientWidth;
    T = topInset + 12;
    var headH = head ? head.offsetHeight + 16 : 0;       // heading + its gap, pinned with the card
    H = Math.max(300, Math.min(Math.round(W * FH / FW), vh - T - headH - 16, Math.round(vh * 0.74)));
    card.style.height = H + 'px';
    stage.style.height = (headH + H + Math.round(vh * TRACK)) + 'px';
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
    var s = Math.min(W / FW, H / FH), dw = FW * s, dh = FH * s;
    hot.style.left = (W - dw) / 2 + 'px'; hot.style.top = (H - dh) / 2 + 'px';
    hot.style.width = dw + 'px'; hot.style.height = dh + 'px';
    pinState = '';
    redraw();
  }

  /* ---------- hotspots + mobile list: shared BG COM card ---------- */
  function trigger(el, d) {
    el.setAttribute('data-bgh-handle', d.h);
    el.setAttribute('data-bgh-title', d.t);
    el.setAttribute('data-bgh-label', d.l || LABEL);
    if (COMPAT) el.setAttribute('data-bgh-compat', COMPAT);
    return el;
  }
  PARTS.forEach(function (d) {
    var b = trigger(document.createElement('button'), d);
    b.type = 'button'; b.className = 'bgh-dot';
    b.style.left = d.x + '%'; b.style.top = d.y + '%';
    b.setAttribute('aria-label', d.t + ' : voir la pièce');
    b.innerHTML = '<span class="bgh-dot__core">' + PLUS + '</span>';
    hot.appendChild(b);
  });
  (function carousel() {
    var c = document.createElement('div'); c.className = 'nv3-carousel';
    c.setAttribute('role', 'group'); c.setAttribute('aria-label', CAROUSEL);   // the module heading above already says what and how many
    var track = document.createElement('div'); track.className = 'nv3-track';
    PARTS.forEach(function (d) {
      var b = trigger(document.createElement('button'), d);
      b.type = 'button'; b.className = 'nv3-pcard';
      b.setAttribute('aria-label', d.t + ' : voir la pièce');
      b.innerHTML = "<span class='nv3-pcard-img' style=\"background-image:url('" + img(d.i) + (d.i.indexOf('?') > -1 ? '&' : '?') + "width=240')\"></span>" +
        "<span class='nv3-pcard-b'><span class='nv3-pcard-ref'>Réf. " + escH(d.s) + "</span><span class='nv3-pcard-t'>" + escH(d.t) + '</span>' +
        "<span class='nv3-pcard-f'><span>Voir · ajouter</span><span class='nv3-pcard-go'>" + PLUS + '</span></span></span>';
      track.appendChild(b);
    });
    c.appendChild(track);
    root.appendChild(c);
  })();
  function bindCards() { if (window.BGH) window.BGH.bind(root); }
  if (window.BGH) bindCards(); else document.addEventListener('bgh:ready', bindCards, { once: true });

  var hsOn = false;
  function setHotspots(on) {
    if (on === hsOn) return;
    hsOn = on;
    hot.classList.toggle('is-live', on);
    root.classList.toggle('nv3-hs', on);
    if (!on && window.BGH) window.BGH.close();
  }
  function setSpecs(p) {
    for (var i = 0; i < specs.length; i++) {
      var f = parseFloat(specs[i].getAttribute('data-from')), t = parseFloat(specs[i].getAttribute('data-to'));
      specs[i].classList.toggle('is-on', p >= f && p < t);
    }
  }

  /* ---------- mobile / reduced motion: video in the card + parts list ---------- */
  var mobileStarted = false;
  function startMobile() {
    if (mobileStarted) return;
    mobileStarted = true;
    if (!video.querySelector('source')) {
      var s = document.createElement('source'); s.src = root.getAttribute('data-video'); s.type = 'video/mp4'; video.appendChild(s);
    }
    video.preload = 'metadata'; video.loop = false;
    /* the animation opens on black: keep the sharp still on top until frames really play; if the
       phone refuses autoplay (e.g. iOS Low Power Mode) show the exploded still and play on tap */
    var cover = document.createElement('button');
    cover.type = 'button'; cover.className = 'nv3-cover';
    cover.setAttribute('aria-label', "Lire l'animation de la vue éclatée");
    cover.style.backgroundImage = "url('" + (stillStartSrc || poster || '') + "')";
    pin.appendChild(cover);
    var loaded = false, inView = false;
    video.addEventListener('playing', function () { cover.classList.add('is-off'); });
    function play() {
      if (!loaded) { loaded = true; video.load(); }
      var p = video.play();
      if (p && p.catch) p.catch(function () {
        if (stillEndSrc) cover.style.backgroundImage = "url('" + stillEndSrc + "')";
        cover.classList.add('is-tap');
      });
    }
    cover.addEventListener('click', function () { if (video.ended) video.currentTime = 0; cover.classList.remove('is-tap'); play(); });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden && inView && loaded && video.paused && !video.ended) play();
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { inView = e.isIntersecting; if (inView && !video.ended && video.paused) play(); });
      }, { threshold: 0.35 }).observe(pin);
    } else play();
  }

  /* ---------- scroll: pin the card under the header while the parts assemble ---------- */
  var ticking = false, pinState = '';
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(measure); } }
  function measure() {
    ticking = false;
    if (mobile()) return;
    var rect = stage.getBoundingClientRect(), total = Math.max(stage.offsetHeight - pin.offsetHeight, 1);
    var y = T - rect.top, p = Math.min(Math.max(y / total, 0), 1);
    var ns = y <= 0 ? 'before' : (y >= total ? 'after' : 'pinned');
    if (ns !== pinState) {
      pinState = ns;
      if (ns === 'pinned') { pin.style.position = 'fixed'; pin.style.top = T + 'px'; pin.style.bottom = 'auto'; pin.style.left = rect.left + 'px'; pin.style.width = W + 'px'; }
      else if (ns === 'before') { pin.style.position = 'absolute'; pin.style.top = '0'; pin.style.bottom = 'auto'; pin.style.left = '0'; pin.style.width = '100%'; }
      else { pin.style.position = 'absolute'; pin.style.top = 'auto'; pin.style.bottom = '0'; pin.style.left = '0'; pin.style.width = '100%'; }
    } else if (ns === 'pinned') { pin.style.left = rect.left + 'px'; }
    setTarget(Math.min(p / HOLD, 1) * (FRAME_COUNT - 1));
    fill.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    setSpecs(p);
    setHotspots(p >= HS_AT);
    root.classList.toggle('nv3-go', p > 0.1);            // prompt stays while the card settles, gone once scrubbing is under way
  }
  /* the prompt button runs the whole animation: scroll to where the parts become clickable */
  cta.addEventListener('click', function () {
    var total = stage.offsetHeight - pin.offsetHeight;
    var top = window.pageYOffset + stage.getBoundingClientRect().top - T + total * Math.min(1, HS_AT + 0.04);
    window.scrollTo({ top: Math.round(top), behavior: reduce.matches ? 'auto' : 'smooth' });
  });

  function init() {
    layout();
    if (mobile()) { setHotspots(false); startMobile(); return; }
    if (!('IntersectionObserver' in window)) startLoading();
    measure();
  }
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es, o) { es.forEach(function (e) { if (e.isIntersecting) { startLoading(); o.disconnect(); } }); }, { rootMargin: '200% 0px' }).observe(root);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  var rz;
  window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { layout(); if (!mobile()) measure(); }, 120); }, { passive: true });
  if (mq.addEventListener) mq.addEventListener('change', function () { pinState = ''; init(); });
  init();
})();
